import { Link } from 'react-router';
import { plural } from '../../../lib/format';
import { trpc } from '../../../lib/trpc';
import { Mono } from '../../../ui/Mono';
import { formatAiCost } from '../copilot-ui';

const JOB_FORMS = ['zadanie AI', 'zadania AI', 'zadań AI'] as const;

/**
 * Licznik zużycia AI w panelu Copilota (Fala 10, kontrola kosztu): zadania AI w bieżącym miesiącu z `ai_jobs`
 * (czat, transkrypcja mowy, szkice, podsumowania), koszt i budżet tylko z „Widzi stawki i kwoty”. Osoba widzi swoje
 * zużycie i swój limit, właściciel / admin / manager — workspace. Link do Ustawień → AI i pamięć → Model i limity.
 */
export function CopilotUsage({ enabled }: { enabled: boolean }) {
  const usage = trpc.ai.usage.useQuery({}, { enabled, staleTime: 30_000, retry: false });
  const u = usage.data;
  if (!u) return null;
  const who = u.scope === 'workspace' ? 'Zespół' : 'Ty';
  return (
    <Link
      to="/ustawienia/ai?zakladka=model"
      className="rounded-xs text-caption text-fg-muted hover:text-fg focus-visible:outline-2 focus-visible:outline-accent"
      aria-label={`Zużycie AI w tym miesiącu (${who.toLowerCase()}): ${u.jobs} ${plural(u.jobs, JOB_FORMS)}${
        u.costPln !== undefined ? `, ${formatAiCost(u.costPln)}` : ''
      }${u.budgetPln ? ` z ${formatAiCost(u.budgetPln)}` : ''}. Otwórz ustawienia AI`}
    >
      <span aria-hidden>
        {who}, ten miesiąc: <Mono>{u.jobs}</Mono> {plural(u.jobs, JOB_FORMS)}
        {u.costPln !== undefined && (
          <>
            {' · '}
            <Mono>{formatAiCost(u.costPln)}</Mono>
            {u.budgetPln ? (
              <>
                {' z '}
                <Mono>{formatAiCost(u.budgetPln)}</Mono>
              </>
            ) : null}
          </>
        )}
      </span>
    </Link>
  );
}
